export default __webpack_public_path__ + "static/media/anime-library.a16814c9.png";